// extracted by mini-css-extract-plugin
export var measureBox = "_de-0";